import ReactDom from 'react-dom'

const PopupWrap = (props) => {

  let el = document.getElementById('page_popup')

  return ReactDom.createPortal(props.children, el)
}

export default PopupWrap;
